import { useMemo } from "react";
import { Box, Chip, Divider, Paper, Skeleton, Typography } from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import AssessmentIcon from "@mui/icons-material/Assessment";

const ConsolidadoTable = ({ data = [], loading }) => {
  const grupos = useMemo(() => {
    const map = new Map();
    data.forEach((row) => {
      if (!map.has(row.id_proveedor)) {
        map.set(row.id_proveedor, { proveedor: row.proveedor, items: [], total: 0 });
      }
      const grupo = map.get(row.id_proveedor);
      grupo.items.push(row);
      grupo.total += Number(row.cantidad) || 0;
    });
    return Array.from(map.values());
  }, [data]);

  const totalGeneral = grupos.reduce((acc, g) => acc + g.total, 0);

  if (loading) {
    return (
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 2 }}>
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} variant="rounded" height={180} sx={{ borderRadius: 3 }} />
        ))}
      </Box>
    );
  }

  if (!grupos.length) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1,
          py: 5,
          color: "text.secondary",
        }}
      >
        <AssessmentIcon sx={{ fontSize: 32, opacity: 0.5 }} />
        <Typography>No hay pedidos para los filtros elegidos.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          borderRadius: 3,
          background: "linear-gradient(135deg, #1F618D 0%, #2E86C1 100%)",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography sx={{ fontWeight: 700 }}>Total de viandas pedidas</Typography>
        <Typography sx={{ fontWeight: 800, fontSize: "1.5rem" }}>{totalGeneral}</Typography>
      </Paper>

      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 2 }}>
        {grupos.map((grupo) => (
          <Paper
            key={grupo.proveedor}
            elevation={0}
            sx={{ p: 2, borderRadius: 3, border: "1px solid rgba(0,0,0,0.08)" }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
              <StorefrontIcon sx={{ color: "#1F618D" }} />
              <Typography sx={{ fontWeight: 700 }}>{grupo.proveedor}</Typography>
            </Box>
            <Divider sx={{ mb: 1 }} />
            {grupo.items.map((item) => (
              <Box
                key={item.id_menu}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  py: 0.5,
                }}
              >
                <Typography variant="body2">{item.menu}</Typography>
                <Chip label={item.cantidad} size="small" color="primary" sx={{ fontWeight: 700 }} />
              </Box>
            ))}
            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography sx={{ fontWeight: 700 }}>Subtotal</Typography>
              <Typography sx={{ fontWeight: 800, color: "#1F618D" }}>{grupo.total}</Typography>
            </Box>
          </Paper>
        ))}
      </Box>
    </Box>
  );
};

export default ConsolidadoTable;
